import React from 'react';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';

export function TextAlignCenter(props: any) {
  const color = props.active ? '#2B8DFF' : '#edeeef';

  return <FormatAlignCenterIcon htmlColor={color} />;
}
